import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import { reducer as notifications } from 'react-notification-system-redux'
import { dialogReducer } from "redux-dialog"

import rule from './rule'

import webservice, { buildBoundActions, buildReducerSelector } from 'iotera-webservice-redux-saga/ducks/webservice'

export const W_REDUCER_KEY = 'w';
export const buildWSelector = (key) => buildReducerSelector(W_REDUCER_KEY, key);
export const buildWBoundActions = (key) => buildBoundActions(key);

export default combineReducers({
    loadingBar : loadingBarReducer,
    notifications,
    dialogReducer,
    [W_REDUCER_KEY]: webservice,
    rule
});
